export default "__VITE_ASSET__LdfLXHq3__"